export { default } from './TemplatePageHeader';
